module.exports = __webpack_public_path__ + "media/banners/czesci-zamienne-menu-27123f48.svg";